export default __webpack_public_path__ + "static/media/SHURE SM7MIC.d43265aa.JPG";